import { isEmpty } from "ramda";
import React, { useEffect, useState } from "react";
import { Calendar, DateObject } from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";

import {
  isMarkOffHolidayPending,
  isApiPending,
} from "../../../dux/apiStatus";
import { markDaysOffHoliday } from "../../../dux/markDaysOffHoliday";
import { updateSpecialSchedule } from "../../../dux/bookNow";
import Loader from "../../shared/UI/Loader/Loader";
import LoaderForButton from "../../shared/UI/LoaderForButton";
import styles from "./Calendar.module.css";

const format = "YYYY/MM/DD";

// Map frontend sport names to backend sport names
const sportMapping = {
  Football: "football",
  "Box Cricket": "box-cricket",
  "Cricket Net": "cricket-net",
  "Pickle Ball": "pickle-ball",
};

export default function App({ type, sport, location }) {
  const [dates, setDates] = useState([]);
  const dispatch = useDispatch();
  const markOffHolidayPending = useSelector(isMarkOffHolidayPending);
  const updateSpecialSchedulePending = useSelector((state) =>
    isApiPending(state, "updateSpecialSchedule")
  );
  const fetchingSpecialScheduleDates = useSelector((state) =>
    isApiPending(state, "fetchSpecialScheduleDates")
  );
  const fetchingHolidayDates = useSelector((state) =>
    isApiPending(state, "fetchHolidayDates")
  );

  const isFetching =
    type === 1 ? fetchingSpecialScheduleDates : fetchingHolidayDates;
  const isSubmitPending =
    type === 1 ? updateSpecialSchedulePending : markOffHolidayPending;

  // Parent owns fetch; only clear selection when tab/sport/location changes
  useEffect(() => {
    setDates([]);
  }, [type, sport, location]);

  const submitHandler = () => {
    if (!location) return;
    if (isEmpty(dates)) return;

    const dateArr = (Array.isArray(dates) ? dates : [dates]).map((date) =>
      date.format("DD/MM/YYYY")
    );

    if (type === 1) {
      dispatch(
        updateSpecialSchedule({
          sport: sportMapping[sport] || sport,
          location: location,
          dates: dateArr,
        })
      );
    } else {
      dispatch(
        markDaysOffHoliday({
          dateArr,
          type,
          sport: sportMapping[sport] || sport,
          location,
        })
      );
    }
  };

  return (
    <div className={styles.container}>
      {isFetching ? (
        <Loader />
      ) : (
        <>
          <Calendar
            multiple
            minDate={new Date()}
            maxDate={new DateObject().add(60, "day")}
            format={format}
            value={dates}
            onChange={setDates}
          ></Calendar>

          <span className={styles.dateTitle}>Selected By You</span>
          <div className={styles.datesContainer}>
            {(!dates || dates.length === 0) && "No dates are selected yet."}
            {Array.isArray(dates) &&
              dates.sort().map((date) => (
                <span key={String(date)} className={styles.dateCard}>
                  {date.format("DD/MM/YYYY")}
                </span>
              ))}
          </div>
          <button
            className={styles.btn}
            onClick={submitHandler}
            disabled={isEmpty(dates) || isSubmitPending}
          >
            {isSubmitPending ? <LoaderForButton /> : "PROCEED"}
          </button>
        </>
      )}
    </div>
  );
}
